import { Box, Container, Typography, Link } from '@mui/material'

export default function PrivacyPolicyPageAr() {
  return (
    <Box dir="rtl" sx={{ minHeight: '100vh', bgcolor: '#f8fafc', py: 6, fontFamily: '"Noto Sans Arabic", "Segoe UI", Tahoma, sans-serif' }}>
      <Container maxWidth="md">
        <Box sx={{ mb: 4, display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <Box component="img" src="/omnitrace_logo.png" alt="OmniTrace" sx={{ width: 36, height: 36 }} />
          <Typography variant="h5" fontWeight={800} color="#0f172a">OmniTrace</Typography>
        </Box>

        <Typography variant="h4" fontWeight={800} color="#0f172a" gutterBottom>
          سياسة الخصوصية
        </Typography>
        <Typography variant="body2" color="#64748b" sx={{ mb: 4 }}>
          آخر تحديث: ١٧ نيسان ٢٠٢٦
        </Typography>

        <Section title="١. المقدمة">
          تقوم OmniTrace ("نحن"، "لدينا"، "خاصتنا") بتشغيل منصة OmniTrace لتتبع المركبات
          عبر نظام تحديد المواقع العالمي (GPS)، بما في ذلك الموقع الإلكتروني على omnitrace.app،
          وتطبيقات الهاتف المحمول لنظامي iOS و Android، والخدمات ذات الصلة (يُشار إليها
          مجتمعة بـ "الخدمة"). توضح سياسة الخصوصية هذه كيفية جمع معلوماتك واستخدامها
          والإفصاح عنها وحمايتها عند استخدامك لخدمتنا.
        </Section>

        <Section title="٢. المعلومات التي نجمعها">
          <b>معلومات الحساب:</b> الاسم، عنوان البريد الإلكتروني، رقم الهاتف، اسم المؤسسة،
          والدور عند التسجيل أو عند إضافتك بواسطة مسؤول النظام.
          <br /><br />
          <b>بيانات الأجهزة والمركبات:</b> موقع GPS، السرعة، الاتجاه، الارتفاع، حالة التشغيل،
          قراءات المستشعرات (مستوى الوقود، درجة الحرارة، جهد البطارية)، ومعرّفات الأجهزة (IMEI/الرقم التسلسلي).
          <br /><br />
          <b>بيانات الاستخدام:</b> تفاعلات التطبيق، الصفحات المعروضة، الميزات المستخدمة،
          مدة الجلسة، تقارير الأعطال، ومقاييس الأداء المجمعة عبر Sentry و Mixpanel.
          <br /><br />
          <b>بيانات المصادقة:</b> كلمات المرور المشفرة، رموز المصادقة الثنائية،
          حالة التسجيل البيومتري، ومعرّفات الأجهزة الموثوقة.
        </Section>

        <Section title="٣. كيف نستخدم معلوماتك">
          نستخدم المعلومات المجمعة من أجل:
          <br />• تقديم خدمات تتبع GPS وإدارة الأسطول في الوقت الفعلي
          <br />• إنشاء تقارير الرحلات والتحليلات ودرجات سلامة السائقين
          <br />• إرسال الإشعارات الفورية والتنبيهات وتقارير البريد الإلكتروني
          <br />• مصادقة المستخدمين وإدارة التحكم في الوصول
          <br />• تحسين خدمتنا من خلال تحليلات الاستخدام
          <br />• الامتثال للالتزامات القانونية
        </Section>

        <Section title="٤. مشاركة البيانات">
          لا نبيع معلوماتك الشخصية. قد نشارك البيانات مع:
          <br />• <b>مؤسستك:</b> يمكن للمسؤولين في مؤسستك عرض بيانات الأجهزة والرحلات
          ونشاط المستخدمين داخل مؤسستهم.
          <br />• <b>شركاء دائرة الثقة:</b> إذا منح المسؤول لديك إمكانية الوصول المشترك
          للأجهزة عبر المؤسسات، فستكون بيانات الأجهزة المشتركة مرئية للمؤسسة الشريكة.
          <br />• <b>مزودو الخدمات:</b> نستخدم خدمات طرف ثالث تشمل Sentry (تتبع الأخطاء)،
          و Mixpanel (التحليلات)، و OneSignal (الإشعارات الفورية)، ومزودي الاستضافة السحابية.
          <br />• <b>المتطلبات القانونية:</b> عندما يتطلب ذلك القانون أو اللوائح أو الإجراءات القانونية.
        </Section>

        <Section title="٥. أمن البيانات">
          نطبق إجراءات أمنية وفقاً للمعايير الصناعية تشمل:
          <br />• تشفير TLS لجميع البيانات أثناء النقل
          <br />• تخزين كلمات المرور بشكل مشفر (bcrypt)
          <br />• مصادقة قائمة على JWT مع رموز قصيرة الأجل
          <br />• التحكم في الوصول القائم على الأدوار
          <br />• عمليات تدقيق أمنية دورية
        </Section>

        <Section title="٦. الاحتفاظ بالبيانات">
          يتم الاحتفاظ ببيانات GPS والمستشعرات لمدة ٩٠ يوماً في قاعدة بيانات السلاسل الزمنية.
          يتم الاحتفاظ بسجلات الرحلات والتنبيهات وبيانات المستخدمين طوال مدة اشتراكك.
          عند حذف الحساب، تتم إزالة جميع البيانات المرتبطة نهائياً خلال ٣٠ يوماً.
        </Section>

        <Section title="٧. حقوقك">
          لديك الحق في:
          <br />• الوصول إلى بياناتك الشخصية
          <br />• طلب تصحيح البيانات غير الدقيقة
          <br />• طلب حذف حسابك وبياناتك
          <br />• إلغاء الاشتراك في تتبع التحليلات (عبر إعدادات التطبيق)
          <br />• إلغاء الأجهزة الموثوقة والجلسات النشطة
          <br /><br />
          تواصل معنا على <Link href="mailto:privacy@omnitrace.app">privacy@omnitrace.app</Link> لممارسة هذه الحقوق.
        </Section>

        <Section title="٨. خصوصية الأطفال">
          خدمتنا غير موجهة للأفراد الذين تقل أعمارهم عن ١٦ عاماً. نحن لا نجمع
          معلومات شخصية من الأطفال عن قصد.
        </Section>

        <Section title="٩. التغييرات على هذه السياسة">
          قد نقوم بتحديث سياسة الخصوصية هذه من وقت لآخر. سنقوم بإخطارك
          بالتغييرات الجوهرية عبر البريد الإلكتروني أو الإشعارات داخل التطبيق.
        </Section>

        <Section title="١٠. اتصل بنا">
          إذا كانت لديك أسئلة حول سياسة الخصوصية هذه، تواصل معنا على:
          <br />البريد الإلكتروني: <Link href="mailto:privacy@omnitrace.app">privacy@omnitrace.app</Link>
          <br />الموقع الإلكتروني: <Link href="https://omnitrace.app">omnitrace.app</Link>
        </Section>

        <Typography variant="body2" color="#94a3b8" sx={{ mt: 6, textAlign: 'center' }}>
          © {new Date().getFullYear()} OmniTrace. جميع الحقوق محفوظة.
        </Typography>
      </Container>
    </Box>
  )
}

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant="h6" fontWeight={700} color="#1e293b" sx={{ mb: 1 }}>
        {title}
      </Typography>
      <Typography variant="body1" color="#475569" sx={{ lineHeight: 1.8 }}>
        {children}
      </Typography>
    </Box>
  )
}
